export default __webpack_public_path__ + "static/media/hob.de6c09f3.png";